module.exports = {"header":{"portalName":"uMotif 门户网站"},"message":{"error":{"default":"对不起，发生了错误。","invalidCode":"输入的代码无效。请再试一次。"}}}